import { Array as A, Option } from 'effect';

import { MARKER_START, markerIndexes } from '@/lib/i18nOverrides/markers';

/** Attributes that carry catalog texts (never an input's value — that is user data). */
export const MARKED_ATTRIBUTES = ['title', 'placeholder', 'aria-label', 'alt'] as const;

/**
 * How many text nodes and text attributes in `root` carry a marker accepted by `matches` — "used in N places on
 * screen". A text node or attribute counts once even if it repeats the key.
 */
export const countMarkedPlaces = (root: Element, matches: (index: number) => boolean): number => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode: (n) => (n.nodeValue?.includes(MARKER_START) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
  });
  const texts = A.unfold(walker.nextNode(), (n) =>
    n ? Option.some([n.nodeValue ?? '', walker.nextNode()]) : Option.none(),
  );
  const selector = MARKED_ATTRIBUTES.map((a) => `[${a}]`).join(',');
  const attributes = Array.from(root.querySelectorAll(selector)).flatMap((el) =>
    MARKED_ATTRIBUTES.flatMap((a) => Option.toArray(Option.fromNullable(el.getAttribute(a)))),
  );
  return [...texts, ...attributes].filter((s) => markerIndexes(s).some(matches)).length;
};
